import { render, staticRenderFns } from "./OutClinicRecite.vue?vue&type=template&id=2b86dade&scoped=true"
import script from "./OutClinicRecite.vue?vue&type=script&lang=js"
export * from "./OutClinicRecite.vue?vue&type=script&lang=js"
import style0 from "./OutClinicRecite.vue?vue&type=style&index=0&id=2b86dade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b86dade",
  null
  
)

export default component.exports